import { createSelector } from 'reselect';

export const spaceIds = (state) => state.spaces.ids;

export const getSpacesById = (state) => state.entities.spaces;

export const getSpacesIsLoading = (state) => state.spaces.isLoading;

export const getActiveSpaceId = (state) => state.spaces.activeSpaceId;

export const getActiveSpace = createSelector(
  [getSpacesById, getActiveSpaceId],
  (spaces, id) => spaces[id] || null,
);

export const getAllSpaces = createSelector(
  [getSpacesById, spaceIds],
  (spaces, ids) => ids.map((id) => spaces[id])
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())),
);

export const getSpaceSelectOptions = createSelector(
  [getSpacesById, spaceIds],
  (spaces, ids) => ids.map((id) => ({ value: id, label: spaces[id].name })),
);
